module.exports = __webpack_public_path__ + "img/srcoll_box_bottom_line.1f334385.png";